/**
 * Where each customer is with the store (ADR-103): a stage worked out from
 * their sold orders when read, and an RFM score on the profile.
 */
export const CUSTOMER_STAGES = ['prospect', 'new', 'active', 'loyal', 'at_risk', 'lost'];
export const CUSTOMER_STAGES_DEFAULTS = { atRiskDays: 90, lostDays: 180, loyalOrders: 3 };
export const CUSTOMER_STAGE_LIMITS = { minDays: 14, maxDays: 3_650, minLoyalOrders: 2, maxLoyalOrders: 100 };
const DAY_MS = 86_400_000;
/**
 * The stage, from sold orders and the last one's time. Recency wins: a loyal
 * customer silent past the at-risk days is at risk. The SQL in the API is the
 * same rule; a test holds them together.
 */
export function customerStage(orders, lastOrderAt, setting = CUSTOMER_STAGES_DEFAULTS, now = new Date()) {
    if (orders <= 0 || !lastOrderAt)
        return 'prospect';
    const last = typeof lastOrderAt === 'string' ? new Date(lastOrderAt) : lastOrderAt;
    const since = now.getTime() - last.getTime();
    if (since >= setting.lostDays * DAY_MS)
        return 'lost';
    if (since >= setting.atRiskDays * DAY_MS)
        return 'at_risk';
    if (orders >= setting.loyalOrders)
        return 'loyal';
    return orders === 1 ? 'new' : 'active';
}
/** The setting as read: anything missing or out of range takes its default, and lost always comes after at risk. */
export function readCustomerStages(value) {
    const record = (value && typeof value === 'object' ? value : {});
    const whole = (field, min, max) => {
        const raw = record[field];
        return Number.isInteger(raw) && raw >= min && raw <= max ? raw : CUSTOMER_STAGES_DEFAULTS[field];
    };
    const { minDays, maxDays, minLoyalOrders, maxLoyalOrders } = CUSTOMER_STAGE_LIMITS;
    const atRiskDays = whole('atRiskDays', minDays, maxDays);
    const lostDays = whole('lostDays', minDays, maxDays);
    return {
        atRiskDays,
        lostDays: lostDays > atRiskDays ? lostDays : Math.min(Math.max(atRiskDays * 2, CUSTOMER_STAGES_DEFAULTS.lostDays), maxDays),
        loyalOrders: whole('loyalOrders', minLoyalOrders, maxLoyalOrders),
    };
}
//# sourceMappingURL=customer-stages.js.map